import {MailStatusEnum, MailTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function mailStatusNameFilter(type: MailStatusEnum): string {
  switch(type) {
    case MailStatusEnum.ToBeSend: return i18n.t(LF.ToBeSend) as string;
    case MailStatusEnum.Sent: return i18n.t(LF.Sent) as string;
    case MailStatusEnum.UnableToSent: return i18n.t(LF.UnableToSent) as string;

  }
}
